import { createSlice } from "@reduxjs/toolkit";
import {
  createClaimantAdministratorAction,
  updateClaimantAdministratorAction,
  deleteClaimantAdministratorAction,
  getClaimantAdministratorByCaseIDAction,
  deleteClaimantAdministratorDocumentAction,
} from "../../actions/ClaimantAdministrator/claimantAdministratorAction";

// ============================================================================
// INITIAL STATE
// ============================================================================

const initialState = {
  administrators: [],
  loading: false,
  error: null,
  success: false,
  successMessage: "",
};

// ============================================================================
// SLICE
// ============================================================================

const claimantAdministratorSlice = createSlice({
  name: "claimantAdministrator",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    // =========================================================================
    // GET COUNSELS BY CASE ID
    // =========================================================================
    builder
      .addCase(getClaimantAdministratorByCaseIDAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getClaimantAdministratorByCaseIDAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.administrators = action.payload.data || [];
        },
      )
      .addCase(
        getClaimantAdministratorByCaseIDAction.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      );

    // =========================================================================
    // CREATE COUNSEL
    // =========================================================================
    builder
      .addCase(createClaimantAdministratorAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createClaimantAdministratorAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Administrator created successfully";
        state.administrators.push(action.payload.data);
      })
      .addCase(createClaimantAdministratorAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // UPDATE COUNSEL
    // =========================================================================
    builder
      .addCase(updateClaimantAdministratorAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateClaimantAdministratorAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Administrator updated successfully";

        const index = state.administrators.findIndex(
          (c) =>
            c.claimantAdministrator_ID ===
            action.payload.data.claimantAdministrator_ID,
        );

        if (index !== -1) {
          state.administrators[index] = action.payload.data;
        }
      })
      .addCase(updateClaimantAdministratorAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // DELETE COUNSEL
    // =========================================================================
    builder
      .addCase(deleteClaimantAdministratorAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteClaimantAdministratorAction.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Administrator deleted successfully";

        state.administrators = state.administrators.filter(
          (c) => c.claimantAdministrator_ID !== action.payload,
        );
      })
      .addCase(deleteClaimantAdministratorAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    // =========================================================================
    // DELETE COUNSEL DOCUMENT
    // =========================================================================
    builder
      .addCase(deleteClaimantAdministratorDocumentAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteClaimantAdministratorDocumentAction.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.successMessage = "Document deleted successfully";
      })
      .addCase(
        deleteClaimantAdministratorDocumentAction.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      );
  },
});

export const { clearError, clearSuccess } = claimantAdministratorSlice.actions;
export default claimantAdministratorSlice.reducer;
